/**
 * Utility functions in case any items are returned un-translated.
 *
 * (This happens sometimes in embedded data for example.)
 */

import { translateObject, translateObjectInverse } from '@huggg/bar-staff';
import auditLogMap from '../translationMaps/auditLogMap';
import brandMap from '../translationMaps/brandMap';
import cardMap from '../translationMaps/cardMap';
import chargeMap from '../translationMaps/chargeMap';
import cursorPaginatedResponseMap from '../translationMaps/cursorPaginatedResponseMap';
import emailMap from '../translationMaps/emailMap';
import hugggDeliveryReportMap from '../translationMaps/hugggDeliveryReportMap';
import hugggMap from '../translationMaps/hugggMap';
import invoiceMap from '../translationMaps/invoiceMap';
import paginatedResponseMap from '../translationMaps/paginatedResponseMap';
import planMap from '../translationMaps/planMap';
import productMap from '../translationMaps/productMap';
import receiptMap from '../translationMaps/receiptMap';
import reportsTransactionMap from '../translationMaps/reportsTransactionMap';
import searchTagMap from '../translationMaps/searchTagMap';
import smsMap from '../translationMaps/smsMap';
import storeMap from '../translationMaps/storeMap';
import superhugggMap from '../translationMaps/superhugggMap';
import teamInviteMap from '../translationMaps/teamInviteMap';
import teamMap from '../translationMaps/teamMap';
import transactionMap from '../translationMaps/transactionMap';
import userMap from '../translationMaps/userMap';
export var mapTranslator = function mapTranslator(invert) {
  return invert ? translateObjectInverse : translateObject;
};
export var translateAuditLog = function translateAuditLog(item) {
  var invert = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return mapTranslator(invert)(auditLogMap, item);
};
export var translateBrand = function translateBrand(item) {
  var invert = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return mapTranslator(invert)(brandMap, item);
};
export var translateCard = function translateCard(item) {
  var invert = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return mapTranslator(invert)(cardMap, item);
};
export var translateCharge = function translateCharge(item) {
  var invert = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return mapTranslator(invert)(chargeMap, item);
};
export var translateCursorPaginatedResponse = function translateCursorPaginatedResponse(item) {
  var invert = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return mapTranslator(invert)(cursorPaginatedResponseMap, item);
};
export var translateEmail = function translateEmail(item) {
  var invert = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return mapTranslator(invert)(emailMap, item);
};
export var translateHugggDeliveryReport = function translateHugggDeliveryReport(item) {
  var invert = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return mapTranslator(invert)(hugggDeliveryReportMap, item);
};
export var translateHuggg = function translateHuggg(item) {
  var invert = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return mapTranslator(invert)(hugggMap, item);
};
export var translateInvoice = function translateInvoice(item) {
  var invert = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return mapTranslator(invert)(invoiceMap, item);
};
export var translatePaginatedResponse = function translatePaginatedResponse(item) {
  var invert = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return mapTranslator(invert)(paginatedResponseMap, item);
};
export var translatePlan = function translatePlan(item) {
  var invert = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return mapTranslator(invert)(planMap, item);
};
export var translateProduct = function translateProduct(item) {
  var invert = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return mapTranslator(invert)(productMap, item);
};
export var translateReceipt = function translateReceipt(item) {
  var invert = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return mapTranslator(invert)(receiptMap, item);
};
export var translateReportsTransaction = function translateReportsTransaction(item) {
  var invert = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return mapTranslator(invert)(reportsTransactionMap, item);
};
export var translateSearchTag = function translateSearchTag(item) {
  var invert = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return mapTranslator(invert)(searchTagMap, item);
};
export var translateSms = function translateSms(item) {
  var invert = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return mapTranslator(invert)(smsMap, item);
};
export var translateStore = function translateStore(item) {
  var invert = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return mapTranslator(invert)(storeMap, item);
};
export var translateSuperhuggg = function translateSuperhuggg(item) {
  var invert = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return mapTranslator(invert)(superhugggMap, item);
};
export var translateTeamInvite = function translateTeamInvite(item) {
  var invert = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return mapTranslator(invert)(teamInviteMap, item);
};
export var translateTeam = function translateTeam(item) {
  var invert = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return mapTranslator(invert)(teamMap, item);
};
export var translateTransaction = function translateTransaction(item) {
  var invert = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return mapTranslator(invert)(transactionMap, item);
};
export var translateUser = function translateUser(item) {
  var invert = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return mapTranslator(invert)(userMap, item);
};